export const BROADCAST_TYPE = 'broadcastType';
export const VENDOR_SEARCH_PARAMS = 'vendor';
